import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { AiOutlineFileSearch } from "react-icons/ai";
import { TiGroup } from "react-icons/ti";
import { MdOutlineQrCodeScanner } from "react-icons/md";
import styles from "./Dashboard.module.scss";
import QrModal from "./qr/QrModal";
import CustomersModal from "./customers/CustomersModal";
import CashierReport from "./reports/CashierReport";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { compare, decrypt } from "n-krypta";
import TotalPointsAdded from "./reports/points/added/TotalPointsAdded";
import TotalPointsDetails from "./reports/points/details/TotalPointsDetails";

export default function Dashboard() {
  const [showQrModal, setShowQrModal] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);

  const [showReportPointsAdded, setShowReportPointsAdded] = useState(false);
  const [showReportPointsDetails, setShowReportPointsDetails] = useState(false);

  const navigate = useNavigate();

  const key = "ShareeCoin_1234567";

  const merchantNamee = useParams().merchant;
  const storedMerchant = useSelector(
    (state) => state.green.admin.login.merchantName
  );

  useEffect(() => {
    if (compare(merchantNamee, storedMerchant, key) === false) {
      navigate(`/${decrypt(storedMerchant, key)}/manager/login`);
    }
  }, [storedMerchant]);

  const handleMerchant = (name) => {
    const capitalLetter = name.replace(/[^A-Z]/g, "");
    const capitalPostion = name.search(capitalLetter);
    const partTwo = name.slice(capitalPostion);
    const partOne = name.substring(capitalPostion, -1);
    const final = partOne.charAt(0).toUpperCase() + partOne.slice(1);
    return `${final} ${partTwo}`;
  };

  return (
    <div className={`${styles.dashboard} p-3`} dir="ltr">
      <Container>
        <Row>
          <Col xs={12}>
            <div className="py-4">
              <h4 className={styles.merchantTitle}>
                {handleMerchant(decrypt(storedMerchant, key)).trim()}
              </h4>
              <p>Food and Beverage</p>
            </div>
          </Col>
          <div className={`${styles.bankContent} p-3`}>
            <Container>
              <Row>
                <Col xs={12} sm={8} md={9} lg={10}>
                  <h4>
                    {handleMerchant(decrypt(storedMerchant, key)).trim()} Points
                  </h4>
                </Col>
                <Col xs={12} sm={4} md={3} lg={2}>
                  <div className="d-grid">
                    <Button
                      variant="light"
                      size="md"
                      className={`${styles.qrBtn}`}
                      onClick={() => {
                        setShowQrModal(true);
                      }}
                    >
                      <MdOutlineQrCodeScanner className="mx-2" />
                      QR
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
            <Container>
              <Row className={`${styles.homeBtnCotentRow} px-0 px-md-5`}>
                <Col xs={12} md={6} className="mb-2 mt-3">
                  <div
                    className={`${styles.homeBtnContent} p-3`}
                    onClick={() => {
                      setShowReportModal(true);
                    }}
                  >
                    <div className={`${styles.homeIcon} text-center`}>
                      <AiOutlineFileSearch />
                    </div>
                    <div className={`${styles.homeTitleBtn} text-center`}>
                      Cashiers Reports
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6} className="mb-2">
                  <div
                    className={`${styles.homeBtnContent} p-3`}
                    onClick={() => {
                      setShowCustomerModal(true);
                    }}
                  >
                    <div className={`${styles.homeIcon} text-center`}>
                      <TiGroup />
                    </div>
                    <div className={`${styles.homeTitleBtn} text-center`}>
                      Customers
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6} className="mb-2">
                  <div
                    className={`${styles.homeBtnContent} p-3`}
                    onClick={() => {
                      setShowReportPointsAdded(true);
                    }}
                  >
                    <div className={`${styles.homeIcon} text-center`}>
                      <AiOutlineFileSearch />
                    </div>
                    <div className={`${styles.homeTitleBtn} text-center`}>
                      Total Poitns Added Reports
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6} className="mb-2">
                  <div
                    className={`${styles.homeBtnContent} p-3`}
                    onClick={() => {
                      setShowReportPointsDetails(true);
                    }}
                  >
                    <div className={`${styles.homeIcon} text-center`}>
                      <AiOutlineFileSearch />
                    </div>
                    <div className={`${styles.homeTitleBtn} text-center`}>
                      Total Points Details Reports
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </Row>
      </Container>
      <QrModal
        show={showQrModal}
        onHide={() => {
          setShowQrModal(false);
        }}
      />
      <CustomersModal
        show={showCustomerModal}
        onHide={() => {
          setShowCustomerModal(false);
        }}
      />
      <CashierReport
        show={showReportModal}
        onHide={() => {
          setShowReportModal(false);
        }}
      />
      <TotalPointsAdded
        show={showReportPointsAdded}
        onHide={() => {
          setShowReportPointsAdded(false);
        }}
      />
      <TotalPointsDetails
        show={showReportPointsDetails}
        onHide={() => {
          setShowReportPointsDetails(false);
        }}
      />
    </div>
  );
}
